// extracted by mini-css-extract-plugin
module.exports = {"content":"dropdown_content__KBjTX"};